// gasGiantGenerator.js
var GasGiantGenerator = pc.createScript('gasGiantGenerator');

GasGiantGenerator.attributes.add('standAlone', {type: 'boolean', title: 'standAlone'});
GasGiantGenerator.attributes.add('planetType', {type: 'string', title: 'planetType'});
GasGiantGenerator.attributes.add('baseSphere', {type: 'entity', title: 'baseSphere'});
GasGiantGenerator.attributes.add('overlaySphere', {type: 'entity', title: 'overlaySphere'});
GasGiantGenerator.attributes.add('ph1',{type: 'entity', title:'loadGfx1'});
GasGiantGenerator.attributes.add('ph2',{type: 'entity', title:'loadGfx2'});
GasGiantGenerator.attributes.add('innerHalo', {type: 'entity', title: 'innerHalo'});
GasGiantGenerator.attributes.add('outerHalo', {type: 'entity', title: 'outerHalo'});
GasGiantGenerator.attributes.add('rings', {type: 'entity', title: 'outerHalo', array:true});
GasGiantGenerator.attributes.add('ringColor', {type: 'curve', color: 'rgba', title: 'ringColor'});
GasGiantGenerator.attributes.add('colorMaps', {type: 'asset', assetType: "texture", array: true});
GasGiantGenerator.attributes.add('plasmaStormColor', {type: 'curve', color: 'rgba', title: 'plasmaStormColor'});
GasGiantGenerator.attributes.add('planetCloudTexture', {type: 'asset', assetType: "texture", array: true});
GasGiantGenerator.attributes.add('plasmaTexture', {type: 'asset', assetType: "texture", array: true});
GasGiantGenerator.attributes.add('detailCloud', {type: 'asset', assetType: "texture"});
GasGiantGenerator.attributes.add('stationProb',{type: 'number', title:'stationProb(1-10)', default:0});
GasGiantGenerator.attributes.add('stations', {type:'entity', array:true});
GasGiantGenerator.attributes.add('satellites', {type:'entity'});

// initialize code called once per entity
GasGiantGenerator.prototype.initialize = function() {
    
    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.theSeed = 0.0;
    this.randomize = 0.0;

    this.textureIndex = 0;
    this.baseSphereMat = this.baseSphere.model.meshInstances[0].material.clone();
    this.baseSphere.model.meshInstances[0].material = this.baseSphereMat;
    // this.baseSphereMat.normalDetailMap = this.detailCloud.resource;
    // this.baseSphereMat.normalDetailMapTiling = 255;
    // this.baseSphereMat.normalDetailMapBumpiness = 2;
    this.baseSphereMat.update();
    this.capsMat = this.baseSphere.model.meshInstances[1].material.clone();
    this.baseSphere.model.meshInstances[1].material = this.capsMat;
    
    this.overlaySphereMat = this.overlaySphere.model.meshInstances[0].material.clone();
    this.overlaySphere.model.meshInstances[0].material = this.overlaySphereMat;
    this.ovrScrollScript = this.overlaySphere.script.GasCloudRotator;
    this.ovrScrollScript.setMaterial(this.overlaySphereMat);
    
    this.innerHaloMat = this.innerHalo.model.model.meshInstances[0].material.clone();
    this.outerHaloMat = this.outerHalo.model.model.meshInstances[0].material.clone();
    this.innerHalo.model.model.meshInstances[0].material = this.innerHaloMat;
    this.outerHalo.model.model.meshInstances[0].material = this.outerHaloMat;
    this.scrollScript = this.baseSphere.script.GasCloudRotator;
    this.scrollScript.setMaterial(this.baseSphereMat);
    this.colors = new pc.Color();
    this.lastRing = null;
    
    //STREAMING TEXTURES
    this.textureAssets = new Array(0);
    this.startTrigger = false;
    
    // RANDOMS:
    this.colorTextureSet = 0;
    this.colorRandom = 0;
    this.randomMap = 0;
    this.emsvInt = 0;
    this.offSet = 0;    
    this.lmOffSet = 0;
    this.ringRnd = 0;
    this.ringMeshIndex = 0;
    this.rngClrRnd = 0;
    this.ovrSphrRndm = 0;
    this.stationRandom = 0;
    
    this.ringColors = new pc.Color();
    
    this.planetIndex = 0;
    this.isloaded = true;
    this.planetIndex = 0;
    this.theColorMap = null;
    this.stationFirst = true;
    //this.app.on('systemGenerator:loadPlanet', this.trigger, this);

};

GasGiantGenerator.prototype.trigger = function (ind) {
    
    
    this.randomize = new Math.seedrandom(this.theSeed);
    
    this.setStations();
    that = this;
    this.isloaded = true;
    //this.textureAssets = [];
    //console.log('PLANETINDEX: ' + this.planetIndex + ' ind: ' + ind);
    this.setRandoms();
};

GasGiantGenerator.prototype.setStations = function(){
    this.stationRandom = Math.floor(this.randomize()*10);
    if(this.stationRandom <= this.stationProb){
        for(var st = 0; st < this.stations.length; st++){
            var strnd = this.randomize();
            var rTrnd = new pc.Vec3(Math.floor(this.randomize()*360), Math.floor(this.randomize()*360), Math.floor(this.randomize()*360));
            if(strnd > 0.5){
                this.stations[st].enabled = true;
                this.stations[st].setLocalEulerAngles(rTrnd);
                //
                //console.info(this.stations[st].children[2].model.model.meshInstances[3].material)
                } else {
                    this.stations[st].enabled = false;
                }
        }
    }
};

GasGiantGenerator.prototype.setRandoms = function() {
    this.colorTextureSet = Math.floor(this.randomize() * this.colorMaps.length); // index for color texture (lightmap slot)
    this.colorRandom = Math.floor(this.randomize()*1000); // color for plasma storms - affects emissive
    this.randomMap = Math.floor(this.randomize()*this.plasmaTexture.length); // diffuse and emissive map from two different arrays
    this.emsvInt = Math.floor(this.randomize()*50); // intensity off storms (emissive)
    this.offSet =  Math.floor(this.randomize()*1000); // texture offset for diffuse and emissive map
    this.lmOffSet = Math.floor(this.randomize()*1000); // lightmap offset - is missused for coloring and therefore affecting color
    this.ringRnd = Math.floor(this.randomize()*1000); // ring - yes or no !??
    this.ringMeshIndex = Math.floor(this.randomize() * this.rings.length); // which ring mesh?
    this.rngClrRnd = Math.floor(this.randomize()*1000); // random value for ring color from curve
    this.ovrSphrRndm = Math.floor(this.randomize()*this.plasmaTexture.length); // overlaySphere with additional noise
    
    this.textureAssets[0] = this.app.assets.find(this.colorMaps[this.colorTextureSet].name, 'texture');
    this.textureAssets[1] = this.app.assets.find(this.plasmaTexture[this.randomMap].name, 'texture');
    this.textureAssets[2] = this.app.assets.find(this.planetCloudTexture[this.randomMap].name, 'texture');
    this.textureAssets[3] = this.app.assets.find(this.planetCloudTexture[this.ovrSphrRndm].name, 'texture');
    
    var seed = 'PLANETx' + 
        this.colorTextureSet + 'x' + 
        this.colorRandom + 'x' + 
        this.randomMap + 'x' + 
        this.emsvInt + 'x' + 
        this.offSet + 'x' + 
        this.lmOffSet + 'x' + 
        this.ringRnd + 'x' + 
        this.ringMeshIndex + 'x' + 
        this.rngClrRnd
    ;
    
   /// console.log('SEED: ' + seed);
    
    this.loadTextures();
};

GasGiantGenerator.prototype.loadTextures = function() {

    this.ph1.enabled = true;
    this.ph2.enabled = true;
    this.baseSphere.enabled = false;
    this.overlaySphere.enabled = false;
    
    var counter = 0;
    var self = that;
    var cnt = this.textureAssets.length;
    
    this.textureAssets.forEach(function(txtAss){
        that.app.assets.load(txtAss);
        txtAss.ready(function(ta){
            counter++;
            if(counter == cnt){
                //console.log('GASGIANT TEXTURES LOADED');
                that.startTrigger = true;
            }
        });
    });
};

GasGiantGenerator.prototype.calcGiant = function() {
   
    this.baseSphereMat.emissiveTint = false;
    if(this.lastRing){
        this.lastRing.enabled = false;
    }
    
    var colorTexture = this.colorMaps[this.colorTextureSet].resource;
    this.theColorMap = colorTexture;
    var emsvMap = this.plasmaTexture[this.randomMap].resource;
    var diffMap = this.planetCloudTexture[this.randomMap].resource;
    //console.log('diffMapBug' + diffMap.name);
    var ovrMp = this.planetCloudTexture[this.ovrSphrRndm].resource;
    
    //console.log('emsvMap: ' + emsvMap.name + ' diffuse: '  + diffMap.name);
    
    this.colors.r = this.plasmaStormColor.get(0).value(this.colorRandom/1000);
    this.colors.g = this.plasmaStormColor.get(1).value(this.colorRandom/1000);
    this.colors.b = this.plasmaStormColor.get(2).value(this.colorRandom/1000);
   // console.log('COLORST SET');
   // console.log('colorsGG: ' + this.colors.r + ', ' + this.colors.g + ', '+ this.colors.b);
    this.baseSphereMat.lightMap = colorTexture;
    this.baseSphereMat.lightMapOffset.y = this.lmOffSet/1000;
    this.baseSphereMat.diffuseMapOffset.x = this.baseSphereMat.diffuseMapOffset.y = this.baseSphereMat.emissiveMapOffset.x = this.baseSphereMat.emissiveMapOffset.y = this.offSet/1000;
    this.baseSphereMat.emissiveIntensity = this.emsvInt/10;
    this.baseSphereMat.emissiveMap = emsvMap;
    this.baseSphereMat.diffuseMap = diffMap;
    this.baseSphereMat.emissive.set(this.colors.r, this.colors.g, this.colors.b, 0);
    
    //console.log('baseSphereMat: ' + this.baseSphereMat.lightMap.name + ' name: ' + this.entity.name + ' clrTxtr: ' + colorTexture.name);
    
    this.overlaySphereMat.opacityMap = ovrMp;
    this.overlaySphereMat.opacityMapOffset.x =this.overlaySphereMat.opacityMapOffset.y = this.offSet / 1000;
    this.overlaySphereMat.diffuse = this.colors;
    
    this.capsMat.lightMap = colorTexture;
    this.capsMat.lightMapOffset.y = this.lmOffSet/1000;
    this.capsMat.diffuseMapOffset.x = this.capsMat.diffuseMapOffset.y = this.capsMat.emissiveMapOffset.x = this.capsMat.emissiveMapOffset.y = this.offSet/1000; 
    this.capsMat.emissiveIntensity = this.emsvInt/10;
    this.capsMat.emissiveMap = emsvMap;
    this.capsMat.diffuseMap = diffMap;
    this.capsMat.emissive.set(this.colors.r, this.colors.g, this.colors.b);

    
    this.innerHaloMat.emissiveMap = colorTexture;
    this.outerHaloMat.emissiveMap = colorTexture;

    //console.log('name: ' + this.capsMat.emissiveMap.name);

    this.baseSphereMat.emissiveTint = true;
    this.innerHaloMat.update();
    this.outerHaloMat.update();
    this.capsMat.update();
    this.baseSphereMat.update();
    this.overlaySphereMat.update();
   // console.log('name: ' + this.baseSphereMat.diffuseMap.name + ' color:' + this.baseSphereMat.emissive + ' int: ' + this.baseSphereMat.emissiveIntensity + ' tint: ' + this.baseSphereMat.emissiveTint);
  
    this.ph1.enabled = false;
    this.ph2.enabled = false;
    this.baseSphere.enabled = true;
    this.overlaySphere.enabled = true;
    
    if(this.ringRnd/1000 > 0.5){
        var rng = this.rings[this.ringMeshIndex];
        this.ringColors.r = this.ringColor.get(0).value(this.rngClrRnd/1000);
        this.ringColors.g = this.ringColor.get(1).value(this.rngClrRnd/1000);
        this.ringColors.b = this.ringColor.get(2).value(this.rngClrRnd/1000);
        rng.enabled = true;
        var  rngEdge = rng.model.meshInstances[0].material;
        var  rngMt = rng.model.meshInstances[1].material;
        rngMt.emissive.set(this.ringColors.r, this.ringColors.g, this.ringColors.b);
        rngMt.update();
        rngEdge.emissive.set(this.ringColors.r, this.ringColors.g, this.ringColors.b);
        rngEdge.update();
        this.lastRing = rng;
    }
    

    for(var clrs = 0; clrs < 5; clrs++){
        this.stations[clrs].children[2].model.model.meshInstances[3].material.emissive = this.colors;
    }
    
    
    var stlRnd = this.randomize();

    if(stlRnd >0.3){
        this.satellites.children[0].particlesystem.reset();
        this.satellites.setLocalPosition(0,0,0);
        this.satellites.children[0].setLocalPosition(0,0,0);
        this.satellites.children[0].particlesystem.play();
        this.satellites.enabled = true;
    } else {
        this.satellites.children[0].particlesystem.reset();
        this.satellites.setLocalPosition(0,0,0);
        this.satellites.children[0].setLocalPosition(0,0,0);
        this.satellites.children[0].particlesystem.stop();
        this.satellites.enabled = false;
    }
    
   this.app.fire('planetLoaded:Planet');
};

// update code called every frame
GasGiantGenerator.prototype.update = function(dt) {
    
    if (this.app.keyboard.wasReleased(pc.KEY_SPACE)) {
        if(this.standAlone){
            this.trigger(0);
        }
    }
    
    if(this.startTrigger){
       // console.log('gg loadMaterials');
        //this.app.fire('planetLoaded:Planet');
        this.isloaded = false;
        this.startTrigger = false;
        this.calcGiant();
    }
    
    // if (this.standAlone) {
    //     if (this.app.keyboard.wasPressed(pc.KEY_SPACE)) {
    //         this.trigger(0);
    //     }
    // }
};

// swap method called for script hot-reloading
// inherit your script state here
// GasGiantGenerator.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

